import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin":"10px","color":"red"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "現在のアカウントからログアウトしますか？", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_stop_outlined = _resolveComponent("stop-outlined")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      name: "basic",
      autocomplete: "off",
      onFinish: _ctx.onFinish,
      onFinishFailed: _ctx.onFinishFailed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "StaffCode",
          name: "email",
          rules: [{ required: true, message: 'Please input your Email!' }],
          "label-col": { span: 4 },
          "wrapper-col": { span: 16 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.email) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "Password",
          name: "password",
          rules: [{ required: true, message: 'Please input your password!' }],
          "label-col": { span: 4 },
          "wrapper-col": { span: 16 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "remember" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.formState.remember,
              "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.remember) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("ログイン情報を保存する")
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Login")
              ]),
              _: 1
            }, 8, ["loading"]),
            (_ctx.visible)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                  _createVNode(_component_stop_outlined, { style: {"margin-right":"10px"} }),
                  _createTextVNode("ログインに失敗しました")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "onFinish", "onFinishFailed"]),
    _createVNode(_component_a_button, { onClick: _ctx.CameraMode }, {
      default: _withCtx(() => [
        _createTextVNode("QRカメラでログイン")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.modalvisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalvisible) = $event)),
      title: "別アカウントでログイン中",
      onOk: _ctx.handleOk,
      onCancel: _ctx.handleCancel,
      closable: false,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "StaffCode:" + _toDisplayString(_ctx.formState.email) + "とは異なるアカウントでログインしています", 1),
        _hoisted_2
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancel"]),
    _createVNode(_component_a_divider, {
      style: {"border-color":"#000"},
      dashed: ""
    })
  ], 64))
}